module.exports = __webpack_public_path__ + "assets/img/index-logo@3x.57ebb516.png";